import styled from 'styled-components';
import React, { Component, PropTypes } from 'react';

const StyledErrorSVG = styled.svg`
  vertical-align: middle;
  margin-right: 0.75em;
  display: inline-block;
`;

class AlertIcon extends Component {
  static propTypes = {
    scale: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    color: PropTypes.string,
  }
  static defaultProps = {
    scale: 1,
    color: '#fff',
  }
  render() {
    const { scale, color } = this.props;
    const baseSize = 30;
    const scaledSize = baseSize * scale;
    return (
      <StyledErrorSVG width={scaledSize} height={scaledSize} viewBox={` 0 0 ${scaledSize} ${scaledSize}`}>
        <g transform={`scale(${scale})`}>
          <path fill={color} d="M15.156 29.619l-14.619-14.619 14.619-14.619 14.621 14.619-14.621 14.619zM2.811 15l12.347 12.347 12.345-12.347-12.347-12.347-12.345 12.347z" />
          <path fill={color} d="M14.072 19.77h2.169v2.111h-2.169v-2.111zM14.149 8.494h2.016l-0.227 9.032h-1.545l-0.244-9.032z" />
        </g>
      </StyledErrorSVG>
    );
  }
}

export default AlertIcon;



/** WEBPACK FOOTER **
 ** ./src/components/ErrorMessage/Alert.js
 **/